import { TabProps } from "@mui/material";
import MuiTab from "@mui/material/Tab";

export const Tab = (props: TabProps) => {
    return <MuiTab {...props} style={{ padding: 0, height: 62, ...props.style }} />;
};
